import { SET, RESET_STATE } from "@/stores/CommumActionTypes";

const actions = {
	[SET]({ commit }, userPreferences)
	{
		commit(SET, userPreferences);
	},
	[RESET_STATE]({ commit })
	{
		commit(RESET_STATE);
	},
};

export default { actions };
